import React from 'react';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {
  sortableHandle,
} from 'react-sortable-hoc';

const IconButtonStyled = styled(IconButton)`
  margin-top: auto;
  margin-bottom: auto;
`

const DragHandle = ({
 ...other
}) => {
  return (
    <IconButtonStyled size="small" {...other}>
      <MenuIcon fontSize="inherit" />
    </IconButtonStyled>
  )
}

export default sortableHandle(DragHandle);
